import '.ac{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.h4{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.ai{align-items:flex-start;}.ssr-plugin'
import '.e3{padding:2rem;}.ssr-plugin'
import '.e9{background:var(--palette-white);}.ssr-plugin'
import '.b5{overflow:hidden;}.ssr-plugin'
import '.bl{position:absolute;}.ssr-plugin'
import '.k2{top:50%;}.ssr-plugin'
import '.k3{right:1rem;}.ssr-plugin'
import '.k4{transform:translateY(-50%);}.ssr-plugin'
import '.k5{width:120px;}.ssr-plugin'
import '.k6{height:120px;}.ssr-plugin'
import '.k7{z-index:0;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.hk{z-index:1;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.k8{max-width:calc(100% - 140px);}.ssr-plugin'
import '.k9{font-size:4rem;}.ssr-plugin'
import '.cj{font-weight:700;}.ssr-plugin'
import '.ka{line-height:100%;}.ssr-plugin'
import '.hg{margin:0px;}.ssr-plugin'
import '.a5{color:var(--brand-secondary);}.ssr-plugin'
import '.a6{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ac n h4 d e ax ai e3 e9 b5"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bl k2 k3 k4 k5 k6 k7 d t ax"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ac hk d e ai u k8"
      >
        <div className="k9 cj ka hg a5 a6"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
